import type { PartnerDto } from "common/models/api/models/PartnerDto";
import { useQuery, UseQueryOptions, UseQueryResult } from "react-query";
import { Queries } from "ui/query/queries";
import { giftcardsApi } from "../api/giftcardsApi";

export interface UseGetPartnerGiftCardStrategiesParams {
    partner?: string;
}

export default function useGetPartnerGiftCardStrategies(
    props?: UseGetPartnerGiftCardStrategiesParams,
    options?: UseQueryOptions<PartnerDto[], unknown, PartnerDto[], (string | undefined)[]>,
): UseQueryResult<PartnerDto[]> {
    return useQuery(
        [Queries.PARTNER_GIFTCARD_STRATEGIES, props?.partner],
        async () => {
            const res = await giftcardsApi.getPartnerGiftCardStrategies({ partner: props?.partner });
            return res.data;
        },
        { ...options },
    );
}
